import {DisposalForm, PremiseStatus, SortBy} from 'features/search/filters/enums';

import {Showing, Tag} from "features/search/types";

export enum PremisesType {
    STORE = '05fd276a-8ba7-4cc1-860b-1facb29446a4',
    OFFICE = '19beac86-eee5-4299-9766-26cf6aa4d74e',
    OFFICE_HOTEL = 'f0867010-b445-40d4-b2b2-98fb4c7ea513',
    WAREHOUSE = 'b36fa126-e347-4647-8633-a5f7b0a5155f',
    RESTAURANT_CAFE = '0452aef7-214b-413f-a56c-f86768dd939c',
    INDUSTRIAL_WORKSHOP = 'e4514465-88c6-4933-bce5-a3ca92dea4ef',
    GYM = '83898ef5-75ac-4d49-9803-8c3293b98ef6',
    OTHER = 'ff51fb4e-6a83-423f-8a52-9e9f651b8644'
}

export interface PremisesObject {
    id: string;
    address: string;
    apartmentNumber: string;
    publishedOnSite: string[];
    objectNumber?: string;
    county: {
        name: string;
        id: string;
        type: string;
    };
    municipality: {
        name: string;
        id: string;
        type: string;
    };
    area: {
        name: string;
        id: string;
        type: string;
    };
    countyName: string;
    municipalityName: string;
    areaName: string;
    keywords: string[];
    stage: string;
    siteOrg: string;
    name: string;
    url: string;
    type: string[];
    floor: number;
    maxFloor: number;
    outDoorSpaces: string[];
    primaryArea: number;
    minArea: number;
    maxArea: number;
    inhabitDate: Date | null;
    inhabitDateDetermined: boolean;
    inhabitDateEnd: Date;
    inhabitDateTimeStamp: number;
    showings: Showing[];
    objectStatus: PremiseStatus;
    searchImage: {
        altText: string;
        url: string;
    };
    image: {
        description: string;
        orgHeight: number;
        orgWidth: number;
        ratio: number;
        url: string;
    };
    fee: number;
    disposalForm: DisposalForm;
    tags: string[];
    sellingDescription: string;
    size: number;
    status?: PremiseStatus;
}

export interface MinMaxArea {
    min: number;
    max: number;
}

export interface PremisesCookieModel {
    minMaxArea: MinMaxArea;
    types: PremisesType[];
    tags: Tag[];
    sort: SortBy;
}
